export default "__VITE_ASSET__B7UK1D7J__"